(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["innerworking"] && !Shopify.designMode) return;
  try {
    
  (() => {})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trendystore-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const faqSections = Array.from(document.querySelectorAll('.ts-faq'));
    if (!faqSections.length) return;

    faqSections.forEach((faqSection) => {
      const items = Array.from(faqSection.querySelectorAll('.ts-faq__item'));
      if (items.length < 2) return;

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          items.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.open = false;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trendystore-product-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTrendystoreGalleries = (root = document) => {
      root.querySelectorAll('[data-trendystore-gallery]').forEach((gallery) => {
        if (gallery.dataset.trendystoreGalleryReady === 'true') return;

        gallery.dataset.trendystoreGalleryReady = 'true';
        const shell = gallery.closest('.trendystore-hero__media-shell');
        const items = Array.from(gallery.querySelectorAll('.trendystore-hero__gallery-item'));
        const previousButton = shell?.querySelector('[data-trendystore-gallery-previous]');
        const nextButton = shell?.querySelector('[data-trendystore-gallery-next]');

        if (items.length < 2 || !previousButton || !nextButton) return;

        const getCurrentIndex = () => {
          if (!gallery.clientWidth) return 0;
          return Math.round(gallery.scrollLeft / gallery.clientWidth);
        };

        const showItem = (index) => {
          const targetIndex = (index + items.length) % items.length;
          items[targetIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        };

        previousButton.addEventListener('click', () => showItem(getCurrentIndex() - 1));
        nextButton.addEventListener('click', () => showItem(getCurrentIndex() + 1));
      });
    };

    initializeTrendystoreGalleries();

    if (!window.__tsTrendystoreGalleryEditorBindingReady) {
      window.__tsTrendystoreGalleryEditorBindingReady = true;
      document.addEventListener('shopify:section:load', (event) => {
        initializeTrendystoreGalleries(event.target);
      });
    }

    if (!window.__tsReleaseItHeroSizingBindingReady) {
      window.__tsReleaseItHeroSizingBindingReady = true;

      const getReleaseItWidth = () => {
        const heroSection = document.querySelector('.trendystore-hero');
        if (!heroSection) return null;

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const variableName = isMobile ? '--ts-release-it-button-width-mobile' : '--ts-release-it-button-width-desktop';
        const rawWidth = getComputedStyle(heroSection).getPropertyValue(variableName).trim();
        return rawWidth || '100%';
      };

      const applyReleaseItWidth = () => {
        const releaseItButton = document.getElementById('rsi_buy_now_button');
        if (!releaseItButton) return;

        const targetWidth = getReleaseItWidth();
        if (!targetWidth) return;

        releaseItButton.style.setProperty('width', targetWidth, 'important');
        releaseItButton.style.setProperty('max-width', '100%', 'important');
        releaseItButton.style.setProperty('display', 'block', 'important');
        releaseItButton.style.setProperty('margin-left', 'auto', 'important');
        releaseItButton.style.setProperty('margin-right', 'auto', 'important');
      };

      applyReleaseItWidth();
      window.addEventListener('load', applyReleaseItWidth);
      window.addEventListener('resize', applyReleaseItWidth);

      const releaseItObserver = new MutationObserver(() => {
        applyReleaseItWidth();
      });

      releaseItObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    if (window.__tsCodScrollBindingReady) return;
    window.__tsCodScrollBindingReady = true;

    const fallbackSelectors = [
      'form._rsi_main_form_element',
      '.rsi-form-main',
      'form[data-page="fields"]',
      '[data-page="fields"]',
      '#shopify-section-1780487592be0dc275'
    ];

    const resolveScrollTarget = (preferredSelector) => {
      const selectors = [];
      if (preferredSelector) selectors.push(preferredSelector);
      selectors.push(...fallbackSelectors);

      for (const selector of selectors) {
        const candidate = document.querySelector(selector);
        if (candidate) return candidate;
      }

      return null;
    };

    const scrollToForm = (button) => {
      const targetSelector = button.getAttribute('data-scroll-target');
      const target = resolveScrollTarget(targetSelector);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      let attempts = 0;
      const maxAttempts = 30;
      const retryTimer = setInterval(() => {
        attempts += 1;
        const asyncTarget = resolveScrollTarget(targetSelector);
        if (asyncTarget || attempts >= maxAttempts) {
          clearInterval(retryTimer);
          if (asyncTarget) {
            asyncTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }, 150);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.ts-innerworking__cta[data-scroll-target]');
      if (!trigger) return;

      event.preventDefault();
      scrollToForm(trigger);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trendystore-scroll-cta"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsScrollCtaBindingReady) return;
    window.__tsScrollCtaBindingReady = true;

    const fallbackSelectors = [
      'form._rsi_main_form_element',
      '.rsi-form-main',
      'form[data-page="fields"]',
      '[data-page="fields"]',
      '#rsi_form_wrapper'
    ];

    const normalizeSelector = (selector) => {
      if (!selector) return '';

      const trimmed = selector.trim();
      if (!trimmed) return '';
      if (trimmed.startsWith('#') || trimmed.startsWith('.') || trimmed.startsWith('[')) return trimmed;

      return `#${trimmed}`;
    };

    const resolveScrollTarget = (preferredSelector) => {
      const selectors = [];
      const normalizedPreferredSelector = normalizeSelector(preferredSelector);
      if (normalizedPreferredSelector) selectors.push(normalizedPreferredSelector);
      selectors.push(...fallbackSelectors);

      for (const selector of selectors) {
        const candidate = document.querySelector(selector);
        if (candidate) return candidate;
      }

      return null;
    };

    const scrollToTarget = (button) => {
      const targetSelector = button.getAttribute('data-scroll-target');
      const target = resolveScrollTarget(targetSelector);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.ts-scroll-cta__button[data-scroll-target]');
      if (!trigger) return;

      event.preventDefault();
      scrollToTarget(trigger);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
